import React from 'react';
import QRCode from "react-qr-code";
import Themes from '../Themes';

function PdfInfo({ theme, walimatulurus2, parentName, message, groomFullname, brideFullname, H2, fontP, location, startTime, endTime, weddingDate, heroStyle, contacts, url, textColor }) {
  const Components = Themes[theme];
  const walimatulurus = (walimatulurus2 === "null") ? "" : (walimatulurus2 || "Walimatulurus");

  const heroPdf = {
    backgroundImage: `url(${Components.bg})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  };

  function convertTo12HourFormat(time24) {
    const [hours, minutes] = time24.split(":");
    const period = hours >= 12 ? "pm" : "am";
    const hours12 = hours % 12 || 12; // Convert 0 to 12 for midnight
  
    return `${hours12}:${minutes} ${period}`;
  }

  const startTimeNew = convertTo12HourFormat(startTime);
  const endTimeNew = convertTo12HourFormat(endTime);

  const weddingDateSet = new Date(weddingDate);
  const weddingDay = getDayFromDate(weddingDateSet);

  const formattedDate = weddingDateSet.toLocaleDateString('ms-MY', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  function getDayFromDate(date) {
    const days = ['Ahad', 'Isnin', 'Selasa', 'Rabu', 'Khamis', "Jumaat", 'Sabtu'];
    const dayIndex = date.getDay();
    return days[dayIndex];
  }
  
  const storedContacts = JSON.parse(contacts);

  return (
    <div className={`${Components.themeColor} a6-section w-[105mm] h-[148mm] relative flex flex-col justify-center items-center overflow-hidden ${textColor}`} style={heroPdf} >
      <div className={Components.whiteBg}>
        <div className="text-center">
          <h1 className={`text-xs mb-2 ${fontP} capitalize`}>{walimatulurus}</h1>
          <div className={`text-lg ${H2}`}>
            {parentName.split('\n').map((text, index) => (
              <p key={index}>{text}</p>
            ))}
          </div>
          <div className={`text-xs my-2 ${fontP}`}>
            {message.split('\n').map((text, index) => (
              <p key={index}>{text}</p>
            ))}
          </div>
    
          <div className={`text-lg ${H2}`}>
            {groomFullname.split('\n').map((text, index) => (
              <p key={index}>{text}</p>
            ))}
          </div>
    
          <p className={`text-lg ${H2}`}>&</p>
    
          <div className={`text-lg ${H2}`}>
            {brideFullname.split('\n').map((text, index) => (
              <p key={index}>{text}</p>
            ))}
          </div>      
        </div>
        <div className={`w-full py-4 my-4 px-2 flex items-center justify-between space-x-5 border-t-2 border-b-2 border-dashed`}>
          <div className='w-1/4'>
            <p className={`text-lg ${fontP} font-bold`}>{weddingDay}</p>
            <p className={`text-xs ${fontP}`}>{formattedDate}</p>
          </div>
          <div className='text-center space-y-2 w-1/2'>
            <div className=''>
              <h1 className={`text-xs uppercase font-bold ${fontP}`}>Lokasi</h1>
              {location.split('\n').map((text, index) => (
                <p className={`${fontP} text-xs`} key={index}>{text}</p>
              ))}
            </div>
            <div className=''>
              <h1 className={`text-xs uppercase font-bold ${fontP}`}>Masa</h1>
              <p className={`text-xs ${fontP}`}>{startTimeNew} - {endTimeNew}</p>
            </div>
          </div>
          <div className='text-right w-1/4'>
            <h1 className={`text-xs uppercase font-bold ${fontP}`}>Hubungi</h1>
            {storedContacts.map((contact, index) => (
              <div key={index} className="">
                <p className='text-xs'>{contact.name} :</p>
                <p className='text-xs'>{contact.phoneNumber}</p>
              </div>
            ))}
          </div>
        </div>
        <div className="flex flex-col items-center space-y-2 text-center">
          <QRCode value={url} size={50} />
          <div className=''>
            <p className="text-xs">Imbas untuk</p>
            <p className="text-xs">Kad Digital & Lokasi</p>
          </div>
        </div>
      </div>
      <img
        src={Components.ft}
        className={Components.ftPdf}
      />
      <img
        src={Components.fb}
        className={Components.fbPdf}
      />
    </div>
  );
}

export default PdfInfo;
